<div class="search-results-container">
  <div class="no-search-results" *ngIf="!articles.length; else results">
    <em>We're sorry. We cannot find any matches for your search term.</em>
  </div>
  <ng-template #results>
    <app-articles-result></app-articles-result>
  </ng-template>
</div>